var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStopScreenshare = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 2.66602C1.93029 2.66602 1.33334 3.26297 1.33334 3.99935V11.9993C1.33334 12.7357 1.93029 13.3327 2.66667 13.3327H13.3333C14.0697 13.3327 14.6667 12.7357 14.6667 11.9993V3.99935C14.6667 3.26297 14.0697 2.66602 13.3333 2.66602H2.66667ZM10.1369 5.85599C9.88356 5.60269 9.47437 5.60269 9.22107 5.85599L8 7.08355L6.77245 5.85599C6.51914 5.60269 6.10995 5.60269 5.85665 5.85599C5.60334 6.1093 5.60334 6.51849 5.85665 6.77179L7.08421 7.99935L5.85665 9.22691C5.60334 9.48021 5.60334 9.8894 5.85665 10.1427C6.10995 10.396 6.51914 10.396 6.77245 10.1427L8 8.91515L9.22756 10.1427C9.48087 10.396 9.89005 10.396 10.1434 10.1427C10.3967 9.8894 10.3967 9.48021 10.1434 9.22691L8.9158 7.99935L10.1434 6.77179C10.3902 6.52498 10.3902 6.1093 10.1369 5.85599Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStopScreenshare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stop-screenshare.01e676d7bc7fd407d1ba2b2f005ccea2.svg";